import React from "react";
import { Box, Grid, Rating, Stack } from "@mui/material";
import LandingHeader from "../../../layout/header";
import Footer from "../../../layout/footer";
import { BlueBox, BtnAccess, ReviewBox } from "../style";
import { RootStyle, Text, Title } from "../style";
import { AboutGrid, AboutText, AboutTitle } from "../style";
import AboutImg from "../../../images/landing/financial module.png";
import Icon1 from "../../../images/landing/financial icon 1.png";
import Icon2 from "../../../images/landing/financial icon 2.png";
import Icon3 from "../../../images/landing/financial icon 3.png";
import PartnerLogo from "../../../images/landing/kamran.png";
import { Link } from "react-router-dom";
import AccessNow from "../AccessNow";
import { InnerBlueBox } from "../style";

function FinancialModule() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox sx={{ minHeight: "163px" }}>
            <InnerBlueBox sx={{ p: "0 0 0 32px", maxHeight: "163px" }}>
              <Grid container>
                <AboutGrid item md={7} xs={12}>
                  <AboutTitle>Financial Management System</AboutTitle>
                  <Link to="/inventory/login">
                    <BtnAccess>Access Now</BtnAccess>
                  </Link>
                </AboutGrid>
                <Grid item md={5} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
                  <Box>
                    <img
                      style={{ maxHeight: "163px" }}
                      width="100%"
                      src={AboutImg}
                      alt=""
                    />
                  </Box>
                </Grid>
              </Grid>
            </InnerBlueBox>
          </BlueBox>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Take control of your finances and make informed business decisions
              with our comprehensive Financial Management System.
            </AboutTitle>
            <img src={Icon1} alt="" />
          </Stack>

          <Box
            sx={{
              background: "#F6FFED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={8} xs={12} order={{ xs: 2, md: 1 }}>
                <AboutText>
                  This powerful tool provides you with everything you need to:
                </AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Track daily sales records:</b> Gain real-time insight
                      into your daily income and expenses with the intuitive
                      "Daily Book" feature.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Calculate profit and loss: </b>Analyse the
                      profitability of your daily transactions and identify
                      areas for improvement.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Maintain customer ledgers:</b>Manage individual
                      customer accounts with the "Ledger" feature, easily
                      tracking outstanding payments and balances.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Generate comprehensive reports:</b> Access detailed
                      reports on sales, purchases, and profit and loss, enabling
                      data-driven decision making.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Simplified financial tracking:</b> Manage your finances
                      effortlessly with a user-friendly interface and intuitive
                      features.
                    </AboutText>
                  </li>
                </ul>
              </Grid>
              <Grid item md={4} xs={12} order={{ xs: 1, md: 2 }}>
                <img width="100%" src={Icon2} alt="" />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              background: "#F6FFED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={4} xs={12}>
                <img width="100%" src={Icon3} alt="" />
              </Grid>
              <Grid item md={8} xs={12}>
                <AboutText>Benefits:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhanced financial clarity:</b> Gain a clear
                      understanding of your financial performance and make
                      informed decisions.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Improved cash flow management:</b> Optimise your cash
                      flow by monitoring outstanding payments and identifying
                      potential issues.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Increased profitability: </b> Identify and implement
                      strategies to maximise your profits based on data
                      insights.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Reduced risk:</b> Mitigate financial risks by having
                      complete visibility into your financial health.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Streamlined financial operations:</b> Spend less time
                      on tedious tasks and focus on growing your business.
                    </AboutText>
                  </li>
                </ul>
                <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                  With the Financial Management System, you can simplify your
                  financial management, gain valuable insights, and ultimately,
                  achieve your financial goals.
                </AboutText>
              </Grid>
            </Grid>
          </Box>

          <ReviewBox>
            <Grid container spacing="16px">
              <Grid
                item
                md={6}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Stack>
                  <Text sx={{ color: "#fff" }}>
                    “ManageKaro has truly transformed the way we handle our
                    financial and ledger activities. One of the standout
                    features is the user-friendly interface that makes
                    navigating through financial records a breeze. The
                    platform's design is intuitive, and our team quickly adapted
                    to its functionalities.The comprehensive financial
                    management tools provided by ManageKaro have given us a
                    holistic view of our financial health. From tracking
                    expenses to managing income, the system provides real-time
                    insights that empower us to make informed decisions. This
                    level of transparency has been instrumental in maintaining
                    the financial stability of Kamran Hardware Store.”
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Rating name="simple-controlled" value={5} />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={PartnerLogo} alt="" />
                  <Box>
                    <Title sx={{ color: "#fff" }}>Kamran Hardware Store</Title>
                    <Title sx={{ color: "#fff", fontSize: "24px" }}>
                      Mr Kamran
                    </Title>
                    <Text sx={{ color: "#fff", fontStyle: "italic" }}>
                      Bukhari Plaza, Near DHA 2, G.T Road, Islamabad
                    </Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </ReviewBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default FinancialModule;
